import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";

function RedisSetting() {
    const { fetchRequest } = useMyContext()
    const [formData, setFormData] = useState()
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [formDataError, setFormDataError] = useState({})
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [showOverlay, setShowOverlay] = useState(false);

    const combinedRef = useRef({
        redis_host: null,
        redis_port: null,
        redis_password: null,
    });

    const handleInput = (e) => {
        const { name, value, type } = e.target;

        if (type === 'text') {
            if (name === 'redis_password') {
                if (value.length > 50) {
                    setFormDataError(prev => ({
                        ...prev,
                        [name]: "Password cannot exceed 50 characters",
                    }));
                    return;
                }
            }

            if (name === 'redis_host') {
                if (value.length > 30) {
                    setFormDataError(prev => ({
                        ...prev,
                        [name]: 'Host cannot exceed 30 characters',
                    }));
                    return;
                }

                // Allow only numbers and dots
                if (value === '' || /^[0-9.]*$/.test(value)) {
                    setFormData(prev => ({ ...prev, [name]: value }));
                    setFormDataError(prev => ({ ...prev, [name]: '' }));
                } else {
                    setFormDataError(prev => ({
                        ...prev,
                        [name]: 'Only numbers and dots allowed',
                    }));
                }
                return;
            }


            // Other text inputs
            setFormData(prev => ({ ...prev, [name]: value }));
            setFormDataError(prev => ({ ...prev, [name]: '' }));

        } else if (type === 'number') {
            if (name === 'redis_port') {
                // Remove all non-digit characters
                const numericValue = value.replace(/\D/g, '');

                if (numericValue.length > 15) {
                    setFormDataError(prev => ({
                        ...prev,
                        [name]: "Port cannot exceed 15 digits",
                    }));
                    return;
                }
                if (value === '' || Number(value) < 0) {
                    setFormData(prev => ({ ...prev, [name]: '' }));
                    setFormDataError(prev => ({
                        ...prev,
                        [name]: 'Redis port must be a non-negative number',
                    }));
                    return;
                }
                setFormData(prev => ({ ...prev, [name]: numericValue }));
                setFormDataError(prev => ({ ...prev, [name]: '' }));
            }
        }

    };


    const formValidation = () => {
        let formIsValid = true;

        if (!formData?.redis_port) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                redis_port: "Redis port cannot be empty.",
            }));
            combinedRef.current['redis_port'].focus()
            formIsValid = false;
        } else if (formData.redis_port.length > 15) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                redis_port: "Port cannot exceed 15 digits",
            }));
            combinedRef.current['redis_port'].focus()
            formIsValid = false;
        }
        
        if (formData?.redis_port.length > 1 && new Set(formData?.redis_port.split('')).size === 1) {
            setFormDataError(prev => ({
                ...prev,
                redis_port: 'Redis port cannot consist of all identical digits',
            }));
            combinedRef.current['redis_port'].focus()
            formIsValid = false;
        }

        if (!formData?.redis_password) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                redis_password: "Redis password cannot be empty.",
            }));
            combinedRef.current['redis_password'].focus()
            formIsValid = false;
        } else if (formData.redis_password.length > 50) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                redis_password: "Password cannot exceed 50 characters",
            }));
            combinedRef.current['redis_password'].focus()
            formIsValid = false;
        }

        if (!formData?.redis_host) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                redis_host: "Redis Host cannot be empty.",
            }));
            combinedRef.current['redis_host'].focus()
            formIsValid = false;
        }

        return formIsValid;
    };

    const handleUpdate = async (e) => {
        if (formValidation()) {
            setShowOverlay(true);
            const formDataAdd = {};
            for (const key in formData) {
                if (!["upload_on", "updatedAt", "createdAt"].includes(key)) {
                    formDataAdd[key] = formData[key];
                }
            }
            await fetchRequest({
                method: 'POST',
                url: `${process.env.REACT_APP_Baseurl}/admin/redis-settings-store`,
                params: {},
                data: { ...formDataAdd },
            })
                .then(response => {
                    if (response?.status) {
                        toast.success(response?.message);
                        setShowOverlay(false);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000); // wait for 2 sec before reload
                    }
                }).catch((error) => {
                    toast.error(error?.response?.message || "Something went wrong");
                    setShowOverlay(false);
                });
        }
    };


    useEffect(() => {
        const getRedisSettings = async () => {
            try {
                const response = await fetchRequest({
                    method: 'GET',
                    url: `${process.env.REACT_APP_Baseurl}/admin/redis-settings-index`,
                    params: {},
                    data: {},
                });
                if (response?.status) {
                    setFormData((prev) => ({
                        ...prev,
                        ...response?.redis_setting
                    }));
                }
            } catch (error) {
                console.error(error);
            }
        };
        getRedisSettings();
    }, [withOutRefresh]);

    useEffect(() => {
        const getLabels = async () => {
            try {
                const response = await fetchRequest({
                    method: 'GET',
                    url: `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
                    params: { source: 'site-settings' },
                    data: {},
                });
                if (response?.status) {
                    const result = response?.label_management;
                    setLabelDisplay(result);
                }
            } catch (error) {
                console.error(error);
            }
        };
        getLabels();
    }, []);

    return (
        <>
            {showOverlay && (<Response_Processing />)}
            <AdminBackNavigation text="Back" path="/settings" />
            <AdminSaveHeader heading={labelDisplay?.[6]?.title} saveText={labelDisplay?.[6]?.sub_title} saveMethod={handleUpdate} />
            <FormContainer>
                <div className="col-12 col-md-12">
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[7]?.title} />
                        <MessageLabel text={labelDisplay?.[8]?.title} className="mandatorySimple" />
                        <AdminCustomInput
                            type="text"
                            name="redis_host"
                            value={formData?.redis_host || ''}
                            ref={(el) => (combinedRef.current.redis_host = el)}
                            onChange={handleInput}
                            placeHolder={"redis host"}
                            error={formDataError?.redis_host}
                            maxLength={31}
                        />


                        <MessageLabel text={labelDisplay?.[9]?.title} className="mandatorySimple" />
                        <AdminCustomInput
                            type="number"
                            name="redis_port"
                            value={formData?.redis_port}
                            ref={(el) => (combinedRef.current.redis_port = el)}
                            onChange={handleInput}
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
                            }}
                            placeHolder={"redis port"}
                            error={formDataError?.redis_port}
                            min={0}
                        />


                        <MessageLabel text={labelDisplay?.[10]?.title} className="mandatorySimple" />
                        <AdminCustomInput
                            type="text"
                            name="redis_password"
                            value={formData?.redis_password}
                            ref={(el) => (combinedRef.current.redis_password = el)}
                            onChange={handleInput}
                            placeHolder={"redis password"}
                            error={formDataError?.redis_password}
                            maxLength={51}
                        />

                    </Wrapper>
                </div>
            </FormContainer>
        </>
    );
}

export default RedisSetting;